import { AiSalonAssistant } from '@/components/dashboard/AiSalonAssistant'
import { AppointmentTimeline } from '@/components/dashboard/AppointmentTimeline'
import { AttentionCenter } from '@/components/dashboard/AttentionCenter'
import { BusinessAnalytics } from '@/components/dashboard/BusinessAnalytics'
import { BusinessSnapshot } from '@/components/dashboard/BusinessSnapshot'
import { HeroHeader } from '@/components/dashboard/HeroHeader'
import { KpiGrid } from '@/components/dashboard/KpiGrid'
import { LiveOperations } from '@/components/dashboard/LiveOperations'
import { LuxuryDashboard } from '@/components/dashboard/LuxuryDashboard'
import { OwnerInsightsCharts } from '@/components/dashboard/OwnerInsightsCharts'
import { QuickActionsDock } from '@/components/dashboard/QuickActionsDock'
import { RevenueForecast } from '@/components/dashboard/RevenueForecast'
import { RoomOccupancyOverview } from '@/components/dashboard/RoomOccupancyOverview'
import { TodaysOpportunities } from '@/components/dashboard/TodaysOpportunities'
import { TodaysWin } from '@/components/dashboard/TodaysWin'
import { CommandDashboardProvider } from '@/contexts/CommandDashboardContext'

/**
 * @param {{ apiError?: string }} props
 */
export function LuxuryDashboardContent({ apiError = '' }) {
  return (
    <>
      <div className="mx-auto max-w-[1440px] space-y-5 px-4 py-4 pb-24 sm:space-y-6 sm:py-5 lg:px-6 lg:pb-20">
        {apiError ? (
          <p
            className="rounded-xl bg-destructive/10 px-3 py-2 text-center text-xs font-medium text-destructive sm:text-sm"
            role="alert"
          >
            {apiError}
          </p>
        ) : null}

        <HeroHeader />
        <TodaysWin />
        <KpiGrid />
        <OwnerInsightsCharts />
        <BusinessAnalytics />

        <div className="grid gap-5 lg:grid-cols-2 lg:items-stretch">
          <RevenueForecast />
          <BusinessSnapshot />
        </div>

        <AiSalonAssistant />

        <RoomOccupancyOverview />
        <LiveOperations />

        <div className="grid gap-5 xl:grid-cols-12">
          <div className="xl:col-span-7">
            <AppointmentTimeline />
          </div>
          <div className="space-y-5 xl:col-span-5">
            <AttentionCenter />
            <TodaysOpportunities />
          </div>
        </div>
      </div>
      <QuickActionsDock />
    </>
  )
}

export function LuxuryDashboardWithProvider() {
  return (
    <CommandDashboardProvider>
      <LuxuryDashboard />
    </CommandDashboardProvider>
  )
}
